import { getDateString } from './helper';
import * as S from './style';

export interface TooltipSalariesProps {
  date: string;
  xAlign: 'left' | 'center' | 'right';
  $x: number;
  $y: number;
  $opacity: number;
  salary?: string;
}

export default function TooltipSalaries({
  date,
  salary,
  xAlign,
  $x,
  $y,
  $opacity,
}: TooltipSalariesProps) {
  return (
    <S.Wrapper $x={$x} $y={$y} xAlign={xAlign} $opacity={$opacity}>
      <S.Date>{getDateString(date)}</S.Date>
      <S.Total>{salary}만원</S.Total>
    </S.Wrapper>
  );
}
